import { c as _c } from "react/compiler-runtime";
import ProductMetadata from '@classify/react-product-components/ProductMetadata';
import ProductMetadataDuration from '@classify/react-product-components/ProductMetadataDuration';
import Box from '@classify/react-core-components/Box';
import { translate } from '@openclassrooms/translations';
import { useCourseContext } from '../../_contexts/CourseContext';
import Easy from './images/EasyIcon';
import Medium from './images/MediumIcon';
import Hard from './images/HardIcon';
function CourseMetadata() {
  const $ = _c(13);
  const {
    course
  } = useCourseContext();
  const {
    displayDifficulty,
    difficulty,
    duration
  } = course;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      Easy,
      Medium,
      Hard
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const iconsPerDifficulty = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      durationMonths: _temp,
      durationHours: _temp2,
      durationMinutes: _temp3
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const translations = t1;
  const difficultyIcon = iconsPerDifficulty[difficulty] || Hard;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "row",
      gap: 3
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = translate("courses.accessibility_labels.difficulty");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== difficultyIcon || $[5] !== displayDifficulty) {
    t4 = <ProductMetadata icon={difficultyIcon} shouldNotWrap={true} accessibilityLabel={t3}>{displayDifficulty}</ProductMetadata>;
    $[4] = difficultyIcon;
    $[5] = displayDifficulty;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translate("learning_content.duration.hours.accessibility_label");
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== duration) {
    t6 = <ProductMetadataDuration shouldNotWrap={true} duration={duration} translations={translations} accessibilityLabel={t5} />;
    $[8] = duration;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <Box sx={t2}>{t4}{t6}</Box>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp3(count_1) {
  return translate("learning_content.duration.minutes", {
    count: count_1
  }, count_1);
}
function _temp2(count_0) {
  return translate("learning_content.duration.hours", {
    count: count_0
  }, count_0);
}
function _temp(count) {
  return translate("learning_content.duration.months", {
    count
  }, count);
}
export default CourseMetadata;